// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"3659130f","197":"40fd9f1e","228":"8f09c81e","557":"cefbbe1f","575":"2ef83d8f","590":"27536798","600":"f1bd1828","698":"872b677f"}[chunkId] + ".chunk.css";
};